"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var DeckCache = /*#__PURE__*/function () {
  function DeckCache(getData, convert) {
    _classCallCheck(this, DeckCache);

    _defineProperty(this, "objects", void 0);

    _defineProperty(this, "originals", void 0);

    _defineProperty(this, "updateTrigger", void 0);

    _defineProperty(this, "_idToPosition", void 0);

    _defineProperty(this, "_getData", void 0);

    _defineProperty(this, "_convert", void 0);

    this.objects = [];
    this.originals = [];
    this.updateTrigger = 0;
    this._idToPosition = new Map();
    this._getData = getData;
    this._convert = convert;
  }

  _createClass(DeckCache, [{
    key: "updateAllDeckObjects",
    value: function updateAllDeckObjects() {
      var _this = this;

      if (!this._getData || !this._convert) return;
      this.originals.length = 0;
      this.objects.length = 0;

      this._idToPosition.clear();

      this._getData().forEach(function (d) {
        _this._idToPosition.set(d.id, _this.objects.length);

        _this.originals.push(d);

        _this.objects.push(_this._convert(d));
      });

      this.triggerUpdate();
    }
  }, {
    key: "updateDeckObjectsByIds",
    value: function updateDeckObjectsByIds(ids) {
      var _this2 = this;

      if (!this._getData || !this._convert) return;
      ids.forEach(function (id) {
        var p = _this2._idToPosition.get(id);

        if (p !== undefined) {
          _this2.objects[p] = _this2._convert(_this2.originals[p]);
        }
      });
      this.triggerUpdate();
    }
  }, {
    key: "triggerUpdate",
    value: function triggerUpdate() {
      this.updateTrigger++;
    }
  }, {
    key: "getDeckObjectById",
    value: function getDeckObjectById(id) {
      var p = this._idToPosition.get(id);

      return p !== undefined ? this.objects[p] : null;
    }
  }, {
    key: "getOriginalById",
    value: function getOriginalById(id) {
      var p = this._idToPosition.get(id);

      return p !== undefined ? this.originals[p] : null;
    }
  }]);

  return DeckCache;
}();

exports["default"] = DeckCache;